import { Box, Typography, useTheme } from "@mui/material";

export default function NotFound () {
    const theme = useTheme();
    return(
        <Box sx={{display:"flex", justifyContent:'center', alignItems:'center', height:'100%'}}>
            <Typography variant="h4" fontWeight={500} color={theme.palette.neutral.normal}>Page Not Found!</Typography>
        </Box>
    );
}